export default "__VITE_ASSET__phdSGH4t__"